module.exports = __webpack_public_path__ + "img/rir-logo-default-collapsed.95c6a1b9.svg";